export default __webpack_public_path__ + "static/media/topic1400bg.0cd7e7ab.png";